module.exports = __webpack_public_path__ + "static/images/default.0b6b1b7f0e57a4c0ea581bdb7d1ebc43.jpg";